import { apiGet } from '@gat-ship/http-client'
import type { ClientRef } from '@gat-ship/types'

/**
 * Searches active clients by name / short name against the ref-data stakeholder
 * master. Mirrors `searchVesselsRequest`. The endpoint already scopes results
 * to active clients and returns a flat {@link ClientRef} array.
 *
 * @param query Search text. An empty/blank query yields no results.
 * @param options.limit Max results — defaults to 10, clamped to 50 by the API.
 * @param options.signal Abort signal for cancelling an in-flight search.
 */
export async function searchClientsRequest(
  query: string,
  options?: { limit?: number; signal?: AbortSignal }
): Promise<ClientRef[]> {
  return await apiGet<ClientRef[]>('ref-data/stakeholders/clients/search', {
    params: { query, limit: options?.limit },
    signal: options?.signal
  })
}
